import {BasicPage} from "../basic/BasicPage";
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
import {contentLoader} from "../../loader/loader";
import ReactMarkdown from "react-markdown";

export const PostsPage = ({content}) => {
    return <>
        <BasicPage content={content}/>
        <Posts/>
    </>

}



export const Post = () => {
    const content = contentLoader();
    const {i18n} = useTranslation();
    const {slug} = useParams();
    const _content = content.find(c => c.type === 'post' && c.locale === i18n.language && c.slug === slug);
    let date = new Date(_content.date)

    return <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-10 col-lg-8 pb-4">
                {_content?.image && <img className={'image-fluid pb-4 rounded'} src={_content.image}/>}
                <div>{date.toDateString()}</div>
                <h1 className={'pb-4'}>{_content.name}</h1>
                <ReactMarkdown>{_content.body}</ReactMarkdown>

            </div>
        </div>
    </div>
}

export const RecentPosts = ({limit}) => {
    const content = contentLoader();
    const {i18n} = useTranslation();
    const {slug} = useParams();
    const _content = content.filter(c => c.type === 'post' && c.locale === i18n.language).sort((a, b) => a.date.localeCompare(b.date)).slice(0, limit);
    return _content.map((post, index) => {
        return <div key={index}>{post.name}</div>
    })
}


export const Posts = () => {
    const content = contentLoader();
    const {i18n} = useTranslation();
    const _content = content.filter(c => c.type === 'post' && c.locale === i18n.language);
    return <div className="container pb-4">
        <div className="row">
            {_content.map((post, index) => {
                return <div key={index} className="col-md-4"><NewsCard post={post}/></div>
            })}
        </div>
    </div>

}

const NewsCard = ({post}) => {

    let date = new Date(post.date)
    return <div className={'news-card'}>
        <Link to={`/posts/${post.slug}`}>
            <div className="image_wrapper">
                {post?.image && <img src={post.image}/> }
            </div>
            <span className={'text-white'}>{date.toDateString()}</span>
            <h2 className="title">
                {post.name}
            </h2>
            <div className="short">
                <ReactMarkdown allowedElements={['p']}>{post.body}</ReactMarkdown>
            </div>
        </Link>
    </div>
}